export class WorkflowService {
  activeWorkflowId = null;
}
